<template>
  <div class="detail_content">
    <div class="detail_label">
      {{ titleLabel }}
    </div>
    <div class="corporation_info_label detail_label">
      {{ valueLabel }}
    </div>
    <div
      v-if="isChanged && !isDeleted"
      class="corporation_info_label detail_label is-changed"
    >
      {{ changeLabel }}
    </div>
    <div
      v-if="isDeleted"
      class="corporation_info_label detail_label is-deleted"
    >
      {{ deleteLabel }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    titleLabel: String,
    valueLabel: String,
    changeLabel: String,
    deleteLabel: String,
    isChanged: Boolean,
    isDeleted: Boolean
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
.detail_content .is-changed {
  color: #d32f2f !important;
}
.detail_content .is-deleted {
  color: #d32f2f !important;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/updateValueLabelSection.vue